import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getFirms } from 'Selectors/common';

interface FirmNameCellRendererProps {
    value: string;
}

const FirmNameCellRenderer = (props: FirmNameCellRendererProps) => {
    const { value } = props;

    const firms = useAppSelector(getFirms);
    const firm = firms[value];

    return (
        <span>{firm ? firm.Name : '-'}</span>
    );
};

export default FirmNameCellRenderer;